import {Condition, ImageValue, Perspective, ScoringSystem, ScoringSystemId} from '@legit.health/ui';
import * as Yup from 'yup';
import {
  AnamnesisQuestionsValue,
  ConditionInfo
} from '@/shared/components/diagnosticReport/DiagnosticReportForm/types';
import {definedStringSchema} from '@/shared/utils/yup';
import createScoringSystemSchema from '../../../utils/createScoringSystemSchema';

const videoSchema = Yup.mixed<Blob>().nullable();
const videoSchemaRequired = Yup.mixed<Blob>()
  .nullable()
  .notOneOf([null], 'ui:form.errors.required');

const imageSchema = Yup.mixed<ImageValue>().required();
const imageSchemaRequired = Yup.mixed<ImageValue>()
  .required()
  .test('imageRequired', 'ui:form.errors.required', (value) => Boolean(value?.file));

export default function createSchema({
  condition,
  conditionInfo,
  scoringSystemsById
}: {
  condition: Condition;
  conditionInfo: ConditionInfo | null;
  scoringSystemsById: Record<ScoringSystemId, ScoringSystem>;
}) {
  return Yup.object({
    image: condition.pathology.requiresVideo ? imageSchema : imageSchemaRequired,
    video: condition.pathology.requiresVideo ? videoSchemaRequired : videoSchema,
    scoringSystems: createScoringSystemSchema(
      conditionInfo?.scoringSystemsIds.map((ssId) => scoringSystemsById[ssId] as ScoringSystem) ??
        []
    ),
    conditionId: definedStringSchema,
    patientId: Yup.string().required(),
    visitIdentifier: definedStringSchema,
    anamnesisQuestions: Yup.mixed<AnamnesisQuestionsValue>().required(),
    perspective: Yup.mixed<Perspective>().nullable()
  });
}
